/* MainBlogPage.jsx */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { doc, getDoc, setDoc, updateDoc, increment } from 'firebase/firestore';
import { db } from '../../firebase/firebaseServices'; 
import './blogcss/blog.css';
import blogPages from './blogcards/blogConfig';

// 1) Firebase function for updating blog clicks
async function updateBlogClicks(blog) {
  try {
    // Use the "title" as the document ID (could slugify if needed)
    const docRef = doc(db, 'products', 'blogclicks', 'clicks', blog.title);

    const snapshot = await getDoc(docRef);
    if (snapshot.exists()) {
      // If doc exists, increment the existing 'count' field
      await updateDoc(docRef, {
        count: increment(1),
      });
    } else {
      // If doc doesn't exist, create it with count=1
      await setDoc(docRef, {
        title: blog.title,
        count: 1,
      });
    }
    console.log(`Click count updated for blog: ${blog.title}`);
  } catch (error) {
    console.error('Error updating blog clicks:', error);
  }
}

// 2) Preload images helper
const preloadImages = (imageUrls) => {
  imageUrls.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};

const MainBlogPage = () => {
  useEffect(() => {
    const imageUrls = blogPages.map((blog) => blog.image);
    preloadImages(imageUrls);
  }, []);

  // 3) Handler for blog card click
  const handleBlogCardClick = (blog) => {
    updateBlogClicks(blog);
    console.log('Blog card clicked:', blog.title);

    // Optional: push analytics event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'trackEvent',
      eventCategory: 'Blog',
      eventAction: 'Click',
      eventLabel: blog.title,
    });
  };

  return (
    <div className="main-blog-container">
      <div className="main-blog-header">
        <h1>
          Health and Wellness - Top Quality Vitamins, Weight Loss, Sport Nutrition,
          Workout Gear & Home Gym
        </h1>
      </div>
      <hr
        style={{
          width: '75%',
          margin: '20px auto',
          border: '1px solid #e67e00',
        }}
      />
      <div className="main-blog-cards">
        {blogPages.map((blog, index) => (
          <Link
            to={blog.link}
            key={index}
            className="main-blog-card"
            onClick={() => handleBlogCardClick(blog)}
          >
            <img
              src={blog.image}
              alt={blog.title}
              className="main-blog-card-image"
              loading="lazy"
            />
            <h2 className="main-blog-card-title">{blog.title}</h2>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MainBlogPage;
